import React from 'react';

import artwork from '../../../../Assets/Linkages/SpaceOutreachFilm/Echoes-of-the-Earth-Artwork.png';

const EchoesOfEarth = () => (
  <section className="outreach-film-feature" aria-labelledby="echoes-of-earth-title">
    <div className="outreach-film-feature-inner">
      <figure className="outreach-film-feature-artwork">
        <img src={artwork} alt="Echoes of the Earth original soundtrack artwork" loading="lazy" />
      </figure>

      <div className="outreach-film-feature-copy">
        <p className="section-eyebrow">THE SOUND OF HOPE AND DISCOVERY</p>
        <h2 id="echoes-of-earth-title">Echoes of the Earth</h2>
        <div className="world-space-week-title-line" aria-hidden="true" />
        <p>
          The original soundtrack captures the essence of hope, resilience, and discovery. Every
          note reflects the journey towards unity and sustainability, resonating with the enduring
          strength of the human spirit. It echoes the boundless potential for a brighter future.
        </p>
        <a
          className="outreach-film-trailer-link"
          href="https://www.youtube.com/watch?v=O6KL7dQXoOw"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Watch the Echoes of the Earth original soundtrack on YouTube"
        >
          Watch OST <span aria-hidden="true">→</span>
        </a>
      </div>
    </div>
  </section>
);

export default EchoesOfEarth;
